import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=717747e7&"
import script from "./BugReport.vue?vue&type=script&lang=ts&"
export * from "./BugReport.vue?vue&type=script&lang=ts&"
import style0 from "./BugReport.vue?vue&type=style&index=0&id=717747e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
